import React from "react";

import { QUESTION_TYPES } from "./Types";

const QuestionsInfo = ({section_index, question_index, testObject})=> {
  const question =
    testObject.sections[section_index].questions[question_index];

  if (testObject?.testConfig?.questionInfo == "false") {
    return "";
  }
  return (
    <>
      <div className="question-info">
        <span className="question-type">
          Question Type :
          <span className="category">
            {QUESTION_TYPES.map((questionType, index) => {
              return (
                <>
                  {" "}
                  {question.questionCategory == questionType.value
                    ? questionType.key
                    : ""}{" "}
                </>
              );
            })}
          </span>
        </span>
        <span className="marks_details">
          Marks for correct answer :{" "}
          <font className="green">
            <span>{question.marks}</span>
          </font>{" "}
          ; Negative Marks :{" "}
          <font className="red">
            <span>{question.negativeMarks}</span>
          </font>
        </span>
      </div>
    </>
  );
}

export default QuestionsInfo